<template>
  <a-switch v-model="checked" :disabled="disabled" @change="handleChange"></a-switch>
</template>

<script>
export default {
  name: 'CyCustomSwitch',
  props: {
    check: {
      type: [String, Number, Boolean],
      default: 0
    },
    open: {
      type: [String, Number, Boolean],
      default: 1
    },
    close: {
      type: [String, Number, Boolean],
      default: 0
    },
    syncFun: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    check: {
      handler(value) {
        const bol = value == this.open ? true : false
        this.checked = bol
      },
      immediate: true
    }
  },
  methods: {
    handleChange(e) {
      console.log(e)

      if (this.syncFun) {
        this.syncFun(e ? this.open : this.close)
      } else {
        this.$emit('update:check', e ? this.open : this.close)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
